var React = require('react');

function FillArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.40292 8.45167C6.20312 8.72358 5.79688 8.72358 5.59708 8.45167L0.522781 1.54607C0.280142 1.21586 0.51593 0.749999 0.9257 0.749999L11.0743 0.75C11.4841 0.75 11.7199 1.21586 11.4772 1.54607L6.40292 8.45167Z","fill":"#0577AF"}));
}

FillArrow.defaultProps = {"width":"12","height":"9","viewBox":"0 0 12 9","fill":"none"};

module.exports = FillArrow;

FillArrow.default = FillArrow;
